const teacherEvaluationDetails = {
  path: 'teacherEvaluationDetails/:classEvaluationId',
  component: resolve => require(['../../../../components/pages/student_user/teacherEvaluationDetails'], resolve),
  props: true
}
export default teacherEvaluationDetails
